/**
 * External Dependencies
 */

import 'jquery';

var $ = require('jquery');
import 'masonry-layout';

var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');

// make Flickity a jQuery plugin
Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);
import Parallax from 'parallax-js'
import 'videojs-youtube/dist/Youtube';
import 'flickity-fade/flickity-fade';
import Swiper from 'swiper/bundle';

$(document).ready(function () {
  var swiper = new Swiper(".swiper--slider", {
    effect: "cards",
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var swiper = new Swiper(".simple--slider", {
    draggable: true,
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    on: {
      init: function () {
        if (this.slides.length <= 3) {
          this.allowSlidePrev = this.allowSlideNext = false; // disabling swiping
          // this.el.querySelector(".swiper-prev").setAttribute('hidden', '');  // hiding arrows prev&next
          // this.el.querySelector(".swiper-next").setAttribute('hidden', '');
        }
      }
    },
    // pagination: {
    //   el: '.pagination',
    //   type: 'bullets',
    //   clickable: true,
    // },
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      // when window width is >= 480px
      1024: {
        slidesPerView: 3,
        spaceBetween: 24
      },
    }
  });

  $('.slider').each(function () {
    var highestBox = 0;
    $('.equal', this).each(function () {
      if ($(this).height() > highestBox) {
        highestBox = $(this).height();
      }
    });
    $('.equal', this).height(highestBox);
  });

  // SLIDERS
  if ($('.slider').length) {
    var $carousel = $('.slider').flickity({
      pageDots: true,
      prevNextButtons: true,
      wrapAround: false,
      cellAlign: 'left',
      draggable: true,
    });
  }
  ;

  if ($('.imageslider').length) {
    var $carousel = $('.imageslider').flickity({
      pageDots: false,
      prevNextButtons: true,
      wrapAround: true,
      cellAlign: 'left',
      draggable: true,
      fade: true
    });
  }
  ;

  // SCROLLED NAV
  $(window).on('load scroll', function () {
    if ($(window).scrollTop() > 0) {
      $('body').addClass('scrolled');
    } else {
      $('body').removeClass('scrolled');
    }
  });

  // VACANCY LAYOUT
  var vacancyLayout = localStorage.getItem('layout');
  $('.vacancies__filter').click(function () {
    var filterId = $(this).attr("data-id");
    $('.vacancies__filter').removeClass('active');
    $(this).addClass('active');
    $('body').removeClass('vacancy-grid vacancy-list');
    localStorage.setItem('layout', `${filterId}`);
    $('body').addClass(`${filterId}`);
  });

  const rangeInputs = document.querySelectorAll('.facetwp-radius-slider')

  function handleInputChange(e) {
    let target = e.target
    if (e.target.type !== 'range') {
      target = document.getElementById('range')
    }
    const min = target.min
    const max = target.max
    const val = target.value

    target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
  }

  rangeInputs.forEach(input => {
    input.addEventListener('input', handleInputChange)
  })

  function vacancyView() {
    if (vacancyLayout === 'vacancy-grid') {
      $('body').addClass('vacancy-grid');
      $('.vacancies__filter[data-id="vacancy-grid"]').addClass("active");
    } else {
      $('body').addClass('vacancy-list');
      $('.vacancies__filter[data-id="vacancy-list"]').addClass("active");
    }
  }

  vacancyView();

  // OPEN FILTER
  $('.open-filter').click(function () {
    $(this).toggleClass('active');
    $('body').toggleClass('filter-active');
    $('html').toggleClass('overflow-hidden');
  });

  $('.vacanciesfilter__backdrop').click(function () {
    $('body').removeClass('filter-active');
    $('html').removeClass('overflow-hidden');
  });

  // HAMBURGER
  $('.hamburger').click(function () {
    $(this).toggleClass('active');
    $('body').toggleClass('hamburger-active');
    $('html').toggleClass('overflow-hidden');
  });

  $('.close-nav').click(function () {
    $('.hamburger').toggleClass('active');
    $('body').toggleClass('hamburger-active');
    $('html').toggleClass('overflow-hidden');
  });

  // SEARCH FIELDS
  $('.page-template-archive-vacancies form .facetwp-facet').delegate("*", "focus", function () {
    var elem = $(this);
    setTimeout(function () {
      elem.closest('.facetwp-facet').css('z-index', 999);
      $('body').addClass('search-active');
    }, 0);
  });

  $('.page-template-archive-vacancies form .facetwp-facet').delegate("*", "blur", function () {
    setTimeout(function () {
      $('.facetwp-facet').css('z-index', '');
      $('body').removeClass('search-active');
    }, 0);
  });

  $('#scene').each(function () {
    var scene = document.getElementById('scene');
    var parallaxInstance = new Parallax(scene);
  });

  // COMPANY PAGE
  var lastId,
    topMenu = $('.company-nav__wrapper'),
    topMenuHeight = topMenu.outerHeight(),
    menuItems = topMenu.find('a:not([rel="nofollow"])'),
    scrollItems = menuItems.map(function () {
      var item = $($(this).attr('href'));
      if (item.length) {
        return item;
      }
    });

  menuItems.click(function (e) {
    var href = $(this).attr('href'),
      offsetTop = href === '#' ? 0 : $(href).offset().top - topMenuHeight - 50;
    $('html, body').stop().animate({
      scrollTop: offsetTop,
    }, 500);
    e.preventDefault();
  });

  $(window).scroll(function () {
    // Get container scroll position
    var fromTop = $(this).scrollTop() + topMenuHeight + 51;

    // Get id of current scroll item
    var cur = scrollItems.map(function () {
      if ($(this).offset().top < fromTop)
        return this;
    });
    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : '';

    if (lastId !== id) {
      lastId = id;
      // Set/remove active class
      menuItems
        .parent().removeClass('active')
        /* eslint-disable */
        .end().filter("[href='#" + id + "']").parent().addClass('active');
      /* eslint-enable */
    }
  });

  // $(document).on('click', 'a[href^="#"]', function (event) {
  //   event.preventDefault();
  //   $('body,html').animate({
  //     scrollTop: $($.attr(this, 'href')).offset().top - 50,
  //   }, 500);
  // });

  // Add smooth scrolling to all links
  $(".button").on('click', function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 1000, function () {

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
      return false;
    } // End if
  });


  // LOGO RANDOMIZER
  var max_images = 5;
  var interval_time = 3000;

  var interval = null;

  var active_images = [];
  var hidden_images = [];


  setup();

  // interval for switching
  interval = setInterval(loop, interval_time);

  function setup() {
    // loop through all images and hide the others
    $('.logo-slider--slide').each(function (index, element) {
      if (index >= max_images) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  }


  function loop() {

    hidden_images = $('.logo-slider--slide:hidden').each(function (index2, element) {
      return element;
    });

    active_images = $('.logo-slider--slide:visible').each(function (index1, element) {
      return element;
    });

    var active_random = Math.floor(Math.random() * active_images.length);
    var hidden_random = Math.floor(Math.random() * hidden_images.length);

    var rand_image_hidden = $(hidden_images[hidden_random]);
    var rand_image_active = $(active_images[active_random]);

    swap(rand_image_hidden, rand_image_active);

    // rand_image_hidden.fadeIn();
    // rand_image_active.fadeOut();

    rand_image_hidden.show();
    rand_image_active.hide();


  }

  $(window).on('load resize', function (e) {

    if (this.resizeTO) clearTimeout(this.resizeTO);

    this.resizeTO = setTimeout(function () {
      if ($(window).width() > 768) {
        max_images = 5;
      } else if ($(window).width() > 540) {
        max_images = 3;
      } else {
        max_images = 2;
      }

      setup();

    }, 500);

    // clearInterval(interval);
    // interval = null;
    // if(e.target.innerWidth > 500) {
    //     max_images = 4;
    // } else {
    //     max_images = 2;
    // }
    //
    // setup();
  });

  window.addEventListener("blur", function () {
    clearInterval(interval);
    interval = null;
  });

  window.addEventListener("focus", function () {
    interval = setInterval(loop, interval_time);
  });

  function swap(a, b) {
    a = $(a);
    b = $(b);
    var tmp = $('<span>').hide();
    a.before(tmp);
    b.before(a);
    tmp.replaceWith(b);
  };

  (function ($) {
    $(document).on('facetwp-refresh', function () {
      if (FWP.loaded) {
        $('body').addClass('facetwp-loading');
      }
    });

    $(document).on('facetwp-loaded', function () {
      $('body').removeClass('facetwp-loading');
    });
  })(jQuery);

  // (function($) {
  //     $(function() {
  //         // Make checkbox options semi-transparent
  //         FWP.loading_handler = function(params) {
  //             params.element.find('.facetwp-checkbox').css('opacity', 0.5);
  //         }
  //     });
  // })(jQuery);

  (function ($) {
    $(document).on('facetwp-refresh', function () {
      // $('.facetwp-template').animate({ opacity: 0, transform: translateY(200) }, 500);
      $('.facetwp-template').addClass('searching');
    });
    $(document).on('facetwp-loaded', function () {
      // $('.facetwp-template').animate({ opacity: 1, transform: translateY(0) }, 500);
      $('.facetwp-template').removeClass('searching');
    });
  })(jQuery);

  (function ($) {
    $.ajax({
      url: myAjax.ajaxurl,
      type: 'POST',
      data: {
        action: 'get_post_type_count',
        post_type: 'vacancies'
      },
      success: function(response) {
        $('#post-count-placeholder').text(response);
      },
      error: function() {
        $('#post-count-placeholder').text('Error loading count');
      }
    });
  });

});


